import * as _ from 'underscore';

import { IViz, VizType } from '../models/Viz';
import { Module } from '../Module';
import { ServerService } from '../services/ServerService';
import { VizService } from '../services/VizService';

export interface IWorkbookRevisionVizViewerScope extends ng.IScope {
  viz: IViz;
  headerTitleText: string;
  editedByText: string;
  lastModifiedText: string;
  closeButtonText: string;
  closePreview: () => void;
}

export interface IWorkbookRevisionVizViewerStateParams extends ng.ui.IStateParamsService {
  revisionNumber: number;
  sheetUrlId: string;
  workbookUrlId: string;
}

export class WorkbookRevisionVizViewerCtrl {

  private sheetUrlId: string;

  public static $inject = [
    '$location',
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'ServerService',
    'VizService',
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: IWorkbookRevisionVizViewerScope,
    $state: ng.ui.IStateService,
    $stateParams: IWorkbookRevisionVizViewerStateParams,
    $translate: ng.translate.ITranslateService,
    server: ServerService,
    vizService: VizService
  ) {
    $scope.headerTitleText = $translate.instant('revisionHistoryPreviewTitle', { REVISION_NUMBER: $stateParams.revisionNumber });
    $scope.closePreview = () => { window.close(); };

    const pathElements = _.compact([$stateParams.workbookUrlId, $stateParams.sheetUrlId, 'history', $stateParams.revisionNumber]);
    $scope.viz = {
      path: pathElements.join('/'),
      vizType: VizType.RevisionPreview,
      siteUrlName: server.sessionSiteUrlName(),
      params: $location.search()
    };

    $scope.$watch('viz.path', (newPath: string) => {
      this.sheetUrlId = newPath.split('/')[1];
      vizService.updatePath($scope, {sheetUrlId: this.sheetUrlId});
    });

    vizService.reloadOnLocationChange($scope);
  }
}

Module.instance().controller('WorkbookRevisionVizViewerCtrl', WorkbookRevisionVizViewerCtrl);
